import React, { useEffect } from 'react'
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import Calendar from './Calendar';

import calendarReducer from "./reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = (initialState) => {
  return createStore(
    calendarReducer,
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunk
      )
    )
  );
}

export default function Root(props){
  return(
    <Provider store={store(props)}>
      <Calendar/>
    </Provider>
  )
}